import FaqsItem from "./FaqsItem";
import "./styles.scss";

interface FaqsProps {
  faqsArray: {
    title: string;
    text: string;
  }[];
  compact?: boolean;
}

const Faqs = ({ faqsArray, compact }: FaqsProps) => {
  return (
    <div className={`Faqs ${compact ? "Faqs--compact" : ""}`}>
      {faqsArray.map((item, index) => (
        <FaqsItem
          key={index}
          item={item}
          compact={compact}
        />
      ))}
    </div>
  );
};

export default Faqs;
